// 路由信息，纯JS对象，方便读取路由信息
export default {
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/home.vue'),
      cname: '首页',
    },
    {
      path: '/merchant-detail',
      name: 'merchantDetail',
      component: () => import(/* webpackChunkName: "detail" */ './views/merchant-detail.vue'),
      cname: '商户推荐详情页',
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // https://v3.router.vuejs.org/zh/guide/advanced/scroll-behavior.html#%E5%BC%82%E6%AD%A5%E6%BB%9A%E5%8A%A8
    if (savedPosition) {
      // 在按下 后退/前进 按钮时，就会像浏览器的原生表现那样
      return savedPosition;
    }
    // 滚动到顶部
    return { x: 0, y: 0 };
  },
};
